module.exports = __webpack_public_path__ + "static/img/comunity.826cf942.png";